define( function() {
	"use strict";

	return ( /^$|^module$|\/(?:java|ecma)script/i );
} );



//////////////////
// WEBPACK FOOTER
// ./~/_jquery@3.6.0@jquery/src/manipulation/var/rscriptType.js
// module id = 410
// module chunks = 0